<sham-dash-content class="profile">
  <ng-template shamDashContentSlot="title">
    {{ config.title || 'Profile' }}
  </ng-template>
  @if (saveError()) {
    <div class="mt-3 rounded border border-red-200 bg-red-50 px-3 py-2 text-red-700">
      {{ saveError() }}
    </div>
  }
  @if (saveSuccess()) {
    <div
      class="mt-3 rounded border border-green-200 bg-green-50 px-3 py-2 text-green-700"
    >
      {{ saveSuccess() }}
    </div>
  }
  @if (rejectionReason()) {
    <div
      class="mt-3 rounded border border-amber-200 bg-amber-50 px-3 py-2 text-amber-800"
    >
      Rejection reason: {{ rejectionReason() }}
    </div>
  }

  <div class="mt-4 grid grid-cols-1 gap-3 md:grid-cols-2">
    @for (field of visibleFields(); track field.key) {
      @if (field.inputType === 'date') {
        <dx-date-box
          [label]="field.label"
          labelMode="floating"
          type="date"
          displayFormat="dd/MM/yyyy"
          placeholder="Date of Birth"
          [showClearButton]="false"
          pickerType="calendar"
          [value]="values()[field.key] || null"
          [disabled]="field.editable === false || !profileEditable()"
          [stylingMode]="'outlined'"
          (onValueChanged)="onFieldChange(field.key, $event.value)"
        />
      } @else {
        <dx-text-box
          [label]="field.label"
          labelMode="floating"
          [mode]="inputMode(field)"
          [value]="values()[field.key] || ''"
          [disabled]="field.editable === false || !profileEditable()"
          [stylingMode]="'outlined'"
          (onValueChanged)="onFieldChange(field.key, $event.value)"
        />
      }
    }
  </div>

  <div class="mt-5 flex justify-end">
    <dx-button
      [text]="config.saveButtonText || 'Save Changes'"
      type="default"
      stylingMode="contained"
      [disabled]="saving() || loading() || !profileEditable()"
      (onClick)="onSave()"
    />
  </div>

  @if (config.passwordChangeEndpoint && config.loginPath; as loginPath) {
    <div class="mt-8 flex justify-end">
      <sham-reset-password-button
        [endpoint]="config.passwordChangeEndpoint"
        [loginPath]="loginPath"
      />
    </div>
  }
</sham-dash-content>
